import { render, staticRenderFns } from "./tableData.vue?vue&type=template&id=fafafe56"
import script from "./tableData.vue?vue&type=script&lang=js"
export * from "./tableData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fafafe56')) {
      api.createRecord('fafafe56', component.options)
    } else {
      api.reload('fafafe56', component.options)
    }
    module.hot.accept("./tableData.vue?vue&type=template&id=fafafe56", function () {
      api.rerender('fafafe56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/router/components/tableData.vue"
export default component.exports